// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__LCrF-","profileInfo":"Dashboard_profileInfo__C5Xm2","profileButtons":"Dashboard_profileButtons__UOyMd"};